/// <amd-module name="Build/Admin/Common/Components/ProjectPicker" />
import * as React from "react";

import { ITeamProject } from "TFS/Services/TfsProjectService";

import { Dropdown } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";

import * as Resources from "Build/Admin/Common/Resources";

export interface IProjectPickerProps {
    projects: ITeamProject[];
    onProjectSelected(project: ITeamProject | undefined): void;
}

export class ProjectPicker extends React.PureComponent<IProjectPickerProps> {

    constructor(props: IProjectPickerProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Dropdown
                className="project-picker-dropdown"
                disabled={this.props.projects.length === 0}
                placeholder={Resources.SelectProjectLabel}
                items={this._getProjectItems()}
                onSelect={this._onProjectSelectionChanged} />
        );
    }

    private _getProjectItems(): IListBoxItem<ITeamProject>[] {
        return this.props.projects.map((project: ITeamProject) => {
            return {
                id: project.id,
                text: project.name,
                data: project
            } as IListBoxItem<ITeamProject>;
        });
    }

    private _onProjectSelectionChanged = (event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<ITeamProject>): void => {
        this.props.onProjectSelected(item.data);
    }
}
